import axios, {AxiosRequestConfig} from 'axios';
import Config from '../config';
import { getCookie } from 'typescript-cookie'
import * as utils from '@/lib/utils';

const apiHost = Config.value('VUE_APP_HQ_API_HOST');
const apiKey = Config.value('VUE_APP_HQ_API_KEY');

export default class HqApi {
    private static instance: HqApi;

    private constructor() {}

    public static getInstance() {
        if (!HqApi.instance) {
            HqApi.instance = new HqApi();
        }
        return HqApi.instance;
    }

    async apiGetRequest(endpoint: string) {
            const token = getCookie('token')
            const options: AxiosRequestConfig = {
            method: 'GET',
            url: `${apiHost}/api/web/v1${endpoint}`,
            headers: {
                Authorization: `JWT ${token}`,
                ApiKey: apiKey,
            },
            responseType: 'json',
            withCredentials: true,
        };

        const response = await axios(options);
        return response.data;
    }

    async apiPostRequest(endpoint: string, postBody: object = {}) {
        //@ts-ignore
        const token = getCookie('token')
        const options: AxiosRequestConfig = {
            method: 'POST',
            url: `${apiHost}/api/web/v1${endpoint}`,
            headers: {
                Authorization: `JWT ${token}`,
                ApiKey: apiKey,
            },
            data: postBody,
            responseType: 'json',
            withCredentials: true,
        };

        const response = await axios(options);
        return response.data;
    }

    async tokenPostRequest(endpoint: string, postBody: object = {}) {
        const options: AxiosRequestConfig = {
            method: 'POST',
            url: `${apiHost}/api/web/v1${endpoint}`,
            data: postBody,
            responseType: 'json',
            headers: {
                ApiKey: apiKey,
            },
        };
        const response = await axios(options);
        return response.data;
    }

    async getToken(sessionId: string): Promise<string> {
        const response = await this.tokenPostRequest(`/auth`, {sessionId});
        return response.token;
    }

    async getRides(offset: number,count: number, filters: RidesFilters  ):Promise<Ride[]> {
        const queryFilters = this.buildRidesQueryFilters(filters)
        const queryFiltersWithoutSpaces = queryFilters.replace(/\s+/g, '');
        const response = await this.apiGetRequest(`/sg-reports/rides?offset=${offset}&count=${count}${queryFiltersWithoutSpaces}`);
        return response;
    }

    async getOutstandingCharges(offset: number,count: number, filters: OutstandingChargesFilters):Promise<Ride[]> {
        const queryFilters = this.buildOutstandingChargesQueryFilters(filters)
        const queryFiltersWithoutSpaces = queryFilters.replace(/\s+/g, '');
        const response = await this.apiGetRequest(`/sg-reports/rides/outstanding?offset=${offset}&count=${count}${queryFiltersWithoutSpaces}`);
        return response;
    }

    async downloadRidesRepors(filters: RidesFilters):Promise<Ride[]> {
        const queryFilters = this.buildRidesQueryFilters(filters)
        const queryFiltersWithoutSpaces = queryFilters.replace(/\s+/g, '');
        const response = await this.apiGetRequest(`/sg-reports/rides/download?${queryFiltersWithoutSpaces}`);
        return response;
    }

    async downloadSummaryRepors(filters: RidesFilters, groupBy: string):Promise<Ride[]> {
        const queryFilters = this.buildRidesQueryFilters(filters)
        const queryFiltersWithoutSpaces = queryFilters.replace(/\s+/g, '');
        if(groupBy == 'Car service') {
            groupBy = 'Car provider'
        }
        groupBy = groupBy.toLowerCase().replace(/\s/g, '');
        const response = await this.apiGetRequest(`/sg-reports/rides/summary/by/${groupBy}/download?${queryFiltersWithoutSpaces}`);
        return response;
    }

    async getSummaryData(groupBy: string, offset: number,count: number, filters: SummaryFilters  ):Promise<Ride[]> {
        const queryFilters = this.buildSummaryQueryFilters(filters)
        const queryFiltersWithoutSpaces = queryFilters.replace(/\s+/g, '');
        if(groupBy == 'Car service') {
            groupBy = 'Car provider'
        }
        groupBy = groupBy.toLowerCase().replace(/\s/g, '');
        const response = await this.apiGetRequest(`/sg-reports/rides/summary/by/${groupBy}?offset=${offset}&count=${count}${queryFiltersWithoutSpaces}`);
        return response;
    }

    buildRidesQueryFilters(filters: RidesFilters) {
        const queryFilters = `
            ${filters?.voucherNum ? '&voucherNum=' + filters.voucherNum : ''}
            ${filters?.invoiceNum ? '&invoiceNumberSearch=' + filters.invoiceNum : ''}
            ${filters?.costCenter ? '&costCenterSearch=' + filters.costCenter : ''}
            ${filters?.carProviderName ? '&carProviderNameSearch=' + filters.carProviderName : ''}
            ${filters?.employeeNum ? '&employeeId=' + filters?.employeeNum : ''}
            ${filters?.tripDates?.length == 2 ? '&tripFromDate=' + filters?.tripDates[0] : ''}
            ${filters?.tripDates?.length == 2  ? '&tripToDate=' + filters?.tripDates[1] : ''}
            ${filters?.invoiceDates?.length == 2  ? '&invoiceProcessFromDate=' + filters?.invoiceDates[0] : ''}
            ${filters?.invoiceDates?.length == 2  ? '&invoiceProcessToDate=' + filters?.invoiceDates[1] : ''}
            ${filters?.passenger ? '&passengerNameSearch=' + utils.replaceSpacesWithPercent(filters.passenger) : ''}
        `;
        
        return queryFilters;
    }

    buildOutstandingChargesQueryFilters(filters: OutstandingChargesFilters) {
        const queryFilters = `
            ${filters?.voucherNum ? '&voucherNum=' + filters.voucherNum : ''}
            ${filters?.invoiceNum ? '&invoiceNumberSearch=' + filters.invoiceNum : ''}
            ${filters?.costCenter ? '&costCenterSearch=' + filters.costCenter : ''}
            ${filters?.carProviderName ? '&carProviderNameSearch=' + filters.carProviderName : ''}
            ${filters?.employeeNum ? '&employeeId=' + filters?.employeeNum : ''}
            ${filters?.tripDates?.length == 2 ? '&tripFromDate=' + filters?.tripDates[0] : ''}
            ${filters?.tripDates?.length == 2  ? '&tripToDate=' + filters?.tripDates[1] : ''}
            ${filters?.invoiceDates?.length == 2  ? '&invoiceProcessFromDate=' + filters?.invoiceDates[0] : ''}
            ${filters?.invoiceDates?.length == 2  ? '&invoiceProcessToDate=' + filters?.invoiceDates[1] : ''}
            ${filters?.passenger ? '&passengerNameSearch=' + utils.replaceSpacesWithPercent(filters.passenger) : ''}
            ${filters?.paymentStatus ? '&paymentStatus=' + filters?.paymentStatus : '' }

        `;
        
        return queryFilters;
    }

    buildSummaryQueryFilters(filters: SummaryFilters) {
        const queryFilters = `
            ${filters?.employeeNum ? '&employeeId=' + filters.employeeNum : ''}
            ${filters?.costCenter ? '&costCenterSearch=' + filters.costCenter : ''}
            ${filters?.carProviderName ? '&carProviderNameSearch=' + filters.carProviderName : ''}
            ${filters?.tripDates?.length == 2 ? '&tripFromDate=' + filters?.tripDates[0] : ''}
            ${filters?.tripDates?.length == 2  ? '&tripToDate=' + filters?.tripDates[1] : ''}
            ${filters?.processDates?.length == 2  ? '&invoiceProcessFromDate=' + filters?.processDates[0] : ''}
            ${filters?.processDates?.length == 2  ? '&invoiceProcessToDate=' + filters?.processDates[1] : ''}
        `;
        
        return queryFilters;
    }

    

    async getCreditCards(userId: number): Promise<CreditCardDetails[]> {
        const res = await this.apiGetRequest(`/creditCards?userId=${userId}`);
        return res.userCreditCards;
    }

    async getUserFirmData(): Promise<UserFirmDataResponse> {
        const response = await this.apiGetRequest(`/users/firmData`);
        return response;
    }

    async getCchaToken(): Promise<string> {
        const res = await this.apiGetRequest(`/paymentMethods/token`);
        return res.token;
    }

    
    async getPermittedPassengers(query: string): Promise<ReservationPassenger[]> {
        const { reservationPassengers } = await this.apiGetRequest(`/users/passengers?q=${query}`);
        return reservationPassengers;
    }


    async getCarServicesQuotes(journeyDetails: JourneyDetails): Promise<CarServiceQuote[]> {
        const origin = {
            addressId: journeyDetails.origin.addressId,
            mainText: journeyDetails.origin.mainText,
            secondaryText: journeyDetails.origin.secondaryText,
            exactPickupPoint: journeyDetails.origin.exactPickupPoint,
            googlePlaceId: journeyDetails.origin.googlePlaceId,
            geometry: {
                location: {
                    latitude: journeyDetails.origin.latitude,
                    longitude: journeyDetails.origin.longitude,
                },
            },
        };
        const destination = {
            googlePlaceId: journeyDetails.destination.googlePlaceId,
            addressId: journeyDetails.destination.addressId,
            mainText: journeyDetails.destination.mainText,
            secondaryText: journeyDetails.destination.secondaryText,
            exactPickupPoint: journeyDetails.destination.exactPickupPoint,
            geometry: {
                location: {
                    latitude: journeyDetails.destination.latitude,
                    longitude: journeyDetails.destination.longitude,
                },
            },
        };
        const {dateTime, purposeOfJourneyId, accommodation, isMeetAndGreet, paymentTypeId} = journeyDetails;
         const res = await this.apiPostRequest(`/reservations/availableCarServices`, {
             origin,
             destination,
             dateTime,
             purposeOfJourneyId,
             specialAccomodations: accommodation,
             meetAndGreet: isMeetAndGreet,
             paymentTypeId,
         });
         return res.carServices;
    }

    async getAllocationTypes(): Promise<CostAllocationType[]> {
         const {costAllocationTypes} = await this.apiGetRequest(`/reservations/costAllocationsTypes`);
         return costAllocationTypes;
        /* return [
            {
              id: 1,
              description: 'Project code',
              required: false,
              canAddNew: false
            },
            {
              id: 2,
              description: 'Test code',
              required: false,
              canAddNew: false
            }
          ] */
    }

    async getCostAllocationPredictions(allocationTypeId: number, codePrefix: string): Promise<string[]> {
        const {costAllocations} = await this.apiGetRequest(`/reservations/costAllocations?id=${allocationTypeId}&code=${codePrefix}`);
        return costAllocations;
    }

    async addCreditCard(resultId: string, isDefault: boolean) {
        const res = await this.apiPostRequest(`/paymentMethods/${resultId}`, {setAsDefault: isDefault});
    }

    async createReservation(reservationData: ReservationData, lastStepData: LastStepData): Promise<ReservationResponse> {
        const journeyDetails = reservationData.journey;
        const origin = {
            addressId: journeyDetails.origin.addressId,
            mainText: journeyDetails.origin.mainText,
            secondaryText: journeyDetails.origin.secondaryText,
            exactPickupPoint: journeyDetails.origin.exactPickupPoint,
            geometry: {
                location: {
                    latitude: journeyDetails.origin.latitude,
                    longitude: journeyDetails.origin.longitude,
                },
            },
        };
        const destination = {
            addressId: journeyDetails.destination.addressId,
            mainText: journeyDetails.destination.mainText,
            secondaryText: journeyDetails.destination.secondaryText,
            exactPickupPoint: journeyDetails.destination.exactPickupPoint,
            geometry: {
                location: {
                    latitude: journeyDetails.destination.latitude,
                    longitude: journeyDetails.destination.longitude,
                },
            },
        };

        const {dateTime, purposeOfJourneyId, accommodation, isMeetAndGreet, timeJobHours} = journeyDetails;

        const passengerNames = reservationData.passengers.names.map((n) => n.name);
        const phoneNumbers = reservationData.passengers.phones.map((p) => p.phone);
        const emailAddresses = reservationData.passengers.emails.map((e) => e.address);

        const paymentTypeId = lastStepData.payment.paymentTypeId;
        const paymentMethodId = lastStepData.payment.paymentMethodId;

        const vehicleTypeId = lastStepData.carService?.vehicleTypeId;
        const accountNumber = lastStepData.carService?.accountNumber;
        const carServiceId = lastStepData.carService?.carServiceId;
        const cost = lastStepData.carService?.formattedCost;

        const costAllocations = lastStepData.costAllocations.map((ca) => ({allocationTypeId: ca.costAllocationTypeId, allocationCode: ca.costAllocationValue}));

        return this.apiPostRequest(`/reservations`, {
            origin,
            destination,
            dateTime,
            purposeOfJourneyId,
            specialAccomodations: accommodation,
            meetAndGreet: isMeetAndGreet,
            passengerNames,
            phoneNumbers,
            emailAddresses,
            preferredContactMethod: reservationData.passengers.preferredContactMethod,
            firstPassengerName: reservationData.passengers.names[0].name,
            paymentTypeId,
            paymentMethodId,
            vehicleTypeId,
            accountNumber,
            carServiceId,
            cost,
            costAllocations,
            timeJobHours,
        });
    }
}
